/*
 * @Author: 齐白宇
 * @Date: 2019-09-17 09:56:06
 * @Last Modified by: weimohan
 * @Last Modified time: 2020-07-13 18:23:18
 */


import request from '@/request'
const part_url = '';

/**
 * 账号密码登录
 * @returns 
 */
function userLogin(param) {
  let url = part_url + "auth/login";
  
  return request.post(url,{}, param);
}
/**
 *
 * 手机号登录
 * @param {*} telephone
 * @param {*} phoneCode
 * @returns
 */
function login(telephone, phoneCode) {
  let url = part_url + "userLoginByPhone";
  let param = {
    telephone: telephone,
    phoneCode: phoneCode
  }
  return request.get(url, param);
}

/**
 *
 * 获取QQ授权登录链接
 * @param {*} phone
 * @param {*} type
 * @returns
 */
function getQQAuthorizeUrl(redirectUrl) {
  let url = part_url + "getQQAuthorizeUrl";
  let param = {
    redirectUrl: redirectUrl,
  }
  return request.get(url, param);
}
/**
 * QQ授权登录
 *
 * @param {*} 
 * @returns
 */
function QQPCAuthLogin(param) {
  return request.post('/login/QQPCAuthLogin', param);
}
/**
 *
 * 获取验证码
 * @param {*} phone
 * @param {*} type
 * @returns
 */
function getCode(phone, type) {
  return request.get('/register/sendMessage', {
    phone: phone,
    type: type
  })
}
/**
 * 用户注册
 * @param {*} name 
 * @param {*} telephone 
 * @param {*} code 
 * @param {*} password 
 * @returns 
 */
function registerPc(param) {
  return request.post('/recruit/employee/register',{},param)
}
/**
 * 忘记密码
 * @param {*} data
 * @returns 
 */
function forgetPassword(data) {
  return request.get('/system/user/forgetPassword', data)
}

/**
 * 修改当前用户密码
 *
 * @param {*} passwordOld 旧密码
 * @param {*} passwordNew 新密码
 * @returns
 */
function updatePassword(data) {
  return request.get('/user/updatePassword', data)
}

/**
 * 个人信息详情
 *
 * @param {*} 
 * @returns
 */
function getStudentById(data) {
  return request.get('/user/getStudentById', data)
}
/**
 * 更新个人基础信息
 *
 * @param {*} 
 * @returns
 */
function updateBaseInfo(data) {
  return request.post('/user/updateBaseInfo', {}, data)
}
/**
 * 更新个人基础信息
 *
 * @param {*} 
 * @returns
 */
function authLogin(data) {
  return request.get('/login/wechatAuthLogin', data)
}
/**
 * 查询是开启注销账号功能
 *
 * @param {*} 
 * @returns
 */
 function isLogOff(data) {
  return request.get('/system/config/' + data, {})
}
/**
 * 注销账号
 *
 * @param {*} 
 * @returns
 */
function logOff(data) {
  return request.get('/system/user/logOff', {})
}

/**
 * 校验用户名是否存在
 *
 * @param {*} 
 * @returns
 */
function checkUserName(data) {
  return request.get('/system/user/checkUserName', data)
}


export default {
  login,
  userLogin,
  registerPc,
  getCode,
  forgetPassword,
  updatePassword,
  getStudentById,
  updateBaseInfo,
  authLogin,
  getQQAuthorizeUrl,
  QQPCAuthLogin,
  isLogOff,
  logOff,
  checkUserName
}



// WEBPACK FOOTER //
// ./src/api/user.js